import { render } from "./G01ContentButtonList.vue?vue&type=template&id=0834864c&scoped=true&ts=true"
import script from "./G01ContentButtonList.vue?vue&type=script&lang=ts"
export * from "./G01ContentButtonList.vue?vue&type=script&lang=ts"

import "./G01ContentButtonList.vue?vue&type=style&index=0&id=0834864c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0834864c"]])

export default __exports__